import { Movie } from "src/lib/movieinfo/movieinfotypes";
import { isSameWeek, parseISO } from "date-fns";
import locale from "date-fns/locale/nb";

export function isPremiereThisWeek(movie: Movie): boolean {
	if( movie?.premiere && movie?.isPremiereConfirmed) {
		const prem = parseISO(movie.premiere);
		return isSameWeek(prem, new Date(), { locale, weekStartsOn: 1 });
	}

	return false;
}